// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-item.input-error {
  margin-bottom: 8px !important;
}

ion-radio-group > ion-row {
  gap: 5px;
  margin-bottom: 8px;
}

ion-item {
  --border-width: 0.5px !important;
  --border-radius: 52px !important;
  --border-color: #272727;
  --border-bottom: none;
  border: none;
  margin-top: 0;
}
@media (min-width: 991px) {
  ion-item {
    padding-inline: 3%;
    --min-height: 40px;
  }
}
ion-item:not(:last-child) {
  margin-bottom: 12px;
}
ion-item.no-line {
  --border-color: transparent;
}

.form-row {
  margin-top: 22px;
  zoom: 0.9;
  height: calc(100% - 90px);
}

ion-label {
  font-family: AppFontSemiBold !important;
}

ion-input {
  --border: none !important;
  color: var(--color-black);
}

.no-line {
  border-bottom: 0px;
  --background: transparent;
}

.privacy {
  display: flex;
  align-items: center;
  font-size: 12px;
  color: var(--ion-color-black);
}
.privacy ion-button {
  padding: 0px;
  color: var(--color-black);
  text-transform: capitalize;
}

ion-button {
  --border-radius: 25px;
}

ion-note {
  font-size: 12px;
  padding-right: 10px;
}

ion-item {
  --border-radius: 5px;
  margin-bottom: 0;
}

.terms {
  margin-left: 0px;
}
.terms ion-checkbox {
  margin-right: 10px;
  --checkbox-background-checked: var(--primary-btn);
}
.terms ion-checkbox::part(label) {
  white-space: unset;
}
@media (min-width: 991px) {
  .terms {
    padding: 0;
    position: relative;
    bottom: 5px;
  }
}

ion-checkbox {
  margin-left: 0px;
  width: auto;
}

.stacked {
  position: relative;
  top: -10px;
  left: 0%;
  z-index: 2;
}
@media (min-width: 991px) {
  .stacked {
    left: 3%;
  }
}

ion-label {
  font-size: 15px;
  color: var(--color-black);
  text-transform: uppercase;
  letter-spacing: 0.08em;
}
@media (max-width: 992px) {
  ion-label {
    font-size: 14px;
  }
}

.name-row {
  justify-content: space-between;
}
@media (min-width: 991px) {
  .name-row {
    padding-inline: 3%;
  }
}

.name-col {
  padding: 0;
}
@media (min-width: 991px) {
  .name-col .stacked {
    left: 0;
  }
  .name-col ion-item {
    padding-inline: 0;
  }
  .name-col:first-child {
    padding-right: 7px;
  }
  .name-col:last-child {
    padding-left: 7px;
  }
}

.input-age ion-input {
  height: 100%;
  text-align: center;
  color: var(--color-black);
}
.input-age ion-input:first-child {
  border-right: 1px solid #cbd5e1;
}
.input-age ion-input:last-child {
  border-left: 1px solid #cbd5e1;
}

ion-footer {
  --background: transparent;
  box-shadow: none;
}

.loading {
  height: 50vh;
  align-items: center;
}

@media (max-width: 992px) {
  .wrapper {
    padding: 50px 15px 0;
  }
}
@media (min-width: 991px) {
  .wrapper {
    display: flex;
    flex-direction: column;
  }
}

.button-wrapper {
  display: flex;
  flex-direction: column;
  position: relative;
  justify-content: space-between;
  width: 100%;
  margin-top: auto;
}
.button-wrapper ion-button {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  --background: var(--ion-color-secondary);
}
@media (min-width: 991px) {
  .button-wrapper ion-button {
    min-height: 64px;
    font-size: 20px;
  }
}
.button-wrapper ion-button p {
  margin-top: 5px;
  color: white;
  width: 75%;
}

.wrapper-modal {
  height: 100%;
  position: relative;
  background: var(--ion-color-gray-light);
}
@media (max-width: 992px) {
  .wrapper-modal {
    border-bottom: none;
    box-shadow: rgba(0, 0, 0, 0.1) -1px -13px 12px;
    overflow-y: auto;
    overflow-x: hidden;
  }
}
.wrapper-modal ion-item {
  --background: var(--ion-color-gray-light);
}
.wrapper-modal .close-icon {
  position: absolute;
  top: 15px;
  right: 15px;
  margin: 0px;
  background: var(--color-white-accent);
  width: 18px;
  height: 18px;
  padding: 0px;
  z-index: 99;
}
.wrapper-modal .title-text {
  width: 100%;
  text-align: center;
  color: var(--color-black);
  text-transform: uppercase;
  margin: 30px 0 5px;
  font-size: 24px;
  font-weight: bold;
  letter-spacing: 0.08em;
}
@media (min-width: 991px) {
  .wrapper-modal .title-text {
    padding-top: 0px;
  }
}
.wrapper-modal .subtitle-text {
  font-family: AppFontAlt;
  display: none;
  width: 100%;
  text-align: center;
  color: var(--color-black);
  padding: 10px;
  letter-spacing: 0.02em;
}
@media (min-width: 991px) {
  .wrapper-modal .subtitle-text {
    display: block;
    font-size: 12px;
    padding: 10px;
    margin-bottom: 10px;
  }
}
.wrapper-modal .header-block {
  padding: 20px;
}
@media (min-width: 991px) {
  .wrapper-modal .header-block {
    height: 100%;
    padding: 20px 40px 5px;
  }
}

.underline {
  --border-width: 0px;
  border: none !important;
  color: var(--primary-btn);
}

.error_container {
  margin-bottom: 10px;
}

@media (min-width: 991px) {
  ion-button {
    min-height: 50px !important;
    font-size: 18px !important;
  }
  ion-button:hover {
    --background: var(--primary-btn) !important;
  }
}
.terms_error .input-error {
  position: absolute;
  top: -12px;
  z-index: 9;
}

.input_info {
  position: absolute;
  top: 0;
}

.birth {
  position: relative;
}
@media (min-width: 991px) {
  .birth {
    margin-bottom: 30px;
  }
}
.birth:after {
  content: "";
  height: 1px;
  bottom: 6px;
  position: absolute;
  width: 100%;
  opacity: 0.5;
  background: rgba(38, 38, 38, 0.5019607843);
}

.line {
  border-top: 1px solid #262626;
  position: absolute;
  left: -40px;
  right: -40px;
  top: -20px;
}`, "",{"version":3,"sources":["webpack://./src/app/components/sign-up-modal/sign-up-modal.component.scss","webpack://./src/theme/mixins.scss"],"names":[],"mappings":"AAEA;EACC,6BAAA;AADD;;AAIA;EACC,QAAA;EACA,kBAAA;AADD;;AAGA;EACC,gCAAA;EACA,gCAAA;EACA,uBAAA;EACA,qBAAA;EACA,YAAA;EACA,aAAA;AAAD;ACfE;EDSF;IASE,kBAAA;IACA,kBAAA;EACA;AACF;AACC;EACC,mBAAA;AACF;AAEC;EACC,2BAAA;AAAF;;AAIA;EACC,gBAAA;EACA,SAAA;EACA,yBAAA;AADD;;AAIA;EACC,uCAAA;AADD;;AAIA;EACC,yBAAA;EACA,yBAAA;AADD;;AAGA;EACC,kBAAA;EACA,yBAAA;AAAD;;AAGA;EACC,aAAA;EACA,mBAAA;EAEA,eAAA;EACA,6BAAA;AADD;AAGC;EACC,YAAA;EACA,yBAAA;EACA,0BAAA;AADF;;AAKA;EACC,qBAAA;AAFD;;AAKA;EACC,eAAA;EACA,mBAAA;AAFD;;AAKA;EACC,oBAAA;EACA,gBAAA;AAFD;;AAKA;EACC,gBAAA;AAFD;AAGC;EACC,kBAAA;EACA,iDAAA;AADF;AAIC;EACC,kBAAA;AAFF;ACpFE;ED8EF;IAYE,UAAA;IACA,kBAAA;IACA,WAAA;EAFA;AACF;;AAKA;EACC,gBAAA;EACA,WAAA;AAFD;;AAKA;EACC,kBAAA;EACA,UAAA;EACA,QAAA;EACA,UAAA;AAFD;ACvGE;EDqGF;IAOE,QAAA;EADA;AACF;;AAGA;EACC,eAAA;EACA,yBAAA;EACA,yBAAA;EACA,sBAAA;AAAD;AC7GE;EDyGF;IAOE,eAAA;EACA;AACF;;AAEA;EACC,8BAAA;AACD;AC5HE;ED0HF;IAGE,kBAAA;EAGA;AACF;;AADA;EACC,UAAA;AAID;ACrIE;EDmIA;IACC,OAAA;EAKD;EAHA;IACC,iBAAA;EAKD;EAFA;IACC,kBAAA;EAID;EAFA;IACC,iBAAA;EAID;AACF;;AAAC;EACC,YAAA;EACA,kBAAA;EACA,yBAAA;AAGF;AADC;EACC,+BAAA;AAGF;AADC;EACC,8BAAA;AAGF;;AAAA;EACC,yBAAA;EACA,gBAAA;AAGD;;AADA;EACC,YAAA;EACA,mBAAA;AAID;;ACnKE;EDkKF;IAEE,oBAAA;EAIA;AACF;AC/KE;EDwKF;IAME,aAAA;IACA,sBAAA;EAKA;AACF;;AAFA;EACC,aAAA;EACA,sBAAA;EACA,kBAAA;EACA,8BAAA;EACA,WAAA;EACA,gBAAA;AAKD;AAJC;EACC,WAAA;EAEA,aAAA;EACA,mBAAA;EACA,2BAAA;EACA,wCAAA;AAKF;ACrME;ED0LD;IASE,gBAAA;IACA,eAAA;EAMD;AACF;AALE;EACC,eAAA;EACA,YAAA;EACA,UAAA;AAOH;;AAHA;EASC,YAAA;EACA,kBAAA;EACA,uCAAA;AAFD;AChNE;EDuMF;IAEE,mBAAA;IAEA,8CAAA;IACA,gBAAA;IACA,kBAAA;EAUA;AACF;AALC;EACC,yCAAA;AAOF;AAJC;EACC,kBAAA;EACA,SAAA;EACA,WAAA;EACA,WAAA;EACA,qCAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;EACA,WAAA;AAMF;AAJC;EACC,WAAA;EACA,kBAAA;EACA,yBAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,iBAAA;EACA,sBAAA;AAMF;ACtPE;EDwOD;IAUE,gBAAA;EAQD;AACF;AANC;EACC,uBAAA;EACA,aAAA;EACA,WAAA;EACA,kBAAA;EACA,yBAAA;EACA,aAAA;EACA,sBAAA;AAQF;ACpQE;EDqPD;IAUE,cAAA;IACA,eAAA;IACA,aAAA;IACA,mBAAA;EASD;AACF;AAPC;EACC,aAAA;AASF;AC/QE;EDqQD;IAGE,YAAA;IACA,sBAAA;EAWD;AACF;;AARA;EACC,mBAAA;EACA,uBAAA;EACA,yBAAA;AAWD;;AATA;EACC,mBAAA;AAYD;;AC/RE;EDuRD;IACC,2BAAA;IACA,0BAAA;EAYA;EAXA;IACC,2CAAA;EAaD;AACF;AATC;EACC,kBAAA;EACA,UAAA;EACA,UAAA;AAWF;;AARA;EACC,kBAAA;EACA,MAAA;AAWD;;AARA;EACC,kBAAA;AAWD;ACvTE;ED2SF;IAIE,mBAAA;EAYA;AACF;AAVC;EACC,WAAA;EACA,WAAA;EACA,WAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,0CAAA;AAYF;;AATA;EACC,6BAAA;EACG,kBAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;AAYJ","sourcesContent":["@import '../../../theme/mixins';\n\nion-item.input-error {\n\tmargin-bottom: 8px !important;\n}\n\nion-radio-group > ion-row {\n\tgap: 5px;\n\tmargin-bottom: 8px;\n}\nion-item {\n\t--border-width: 0.5px !important;\n\t--border-radius: 52px !important;\n\t--border-color: #272727;\n\t--border-bottom: none;\n\tborder: none;\n\tmargin-top: 0;\n\n\t@include desktop {\n\t\tpadding-inline: 3%;\n\t\t--min-height: 40px;\n\t}\n\n\t&:not(:last-child) {\n\t\tmargin-bottom: 12px;\n\t}\n\n\t&.no-line {\n\t\t--border-color: transparent;\n\t}\n}\n\n.form-row {\n\tmargin-top: 22px;\n\tzoom: 0.9;\n\theight: calc(100% - 90px);\n}\n\nion-label {\n\tfont-family: AppFontSemiBold !important;\n}\n\nion-input {\n\t--border: none !important;\n\tcolor: var(--color-black);\n}\n.no-line {\n\tborder-bottom: 0px;\n\t--background: transparent;\n}\n\n.privacy {\n\tdisplay: flex;\n\talign-items: center;\n\n\tfont-size: 12px;\n\tcolor: var(--ion-color-black);\n\n\tion-button {\n\t\tpadding: 0px;\n\t\tcolor: var(--color-black);\n\t\ttext-transform: capitalize;\n\t}\n}\n\nion-button {\n\t--border-radius: 25px;\n}\n\nion-note {\n\tfont-size: 12px;\n\tpadding-right: 10px;\n}\n\nion-item {\n\t--border-radius: 5px;\n\tmargin-bottom: 0;\n}\n\n.terms {\n\tmargin-left: 0px;\n\tion-checkbox {\n\t\tmargin-right: 10px;\n\t\t--checkbox-background-checked: var(--primary-btn);\n\t}\n\n\tion-checkbox::part(label) {\n\t\twhite-space: unset;\n\t}\n\n\t@include desktop {\n\t\tpadding: 0;\n\t\tposition: relative;\n\t\tbottom: 5px;\n\t}\n}\n\nion-checkbox {\n\tmargin-left: 0px;\n\twidth: auto;\n}\n\n.stacked {\n\tposition: relative;\n\ttop: -10px;\n\tleft: 0%;\n\tz-index: 2;\n\n\t@include desktop {\n\t\tleft: 3%;\n\t}\n}\nion-label {\n\tfont-size: 15px;\n\tcolor: var(--color-black);\n\ttext-transform: uppercase;\n\tletter-spacing: 0.08em;\n\n\t@include mobile {\n\t\tfont-size: 14px;\n\t}\n}\n\n.name-row {\n\tjustify-content: space-between;\n\t@include desktop {\n\t\tpadding-inline: 3%;\n\t}\n}\n.name-col {\n\tpadding: 0;\n\t@include desktop {\n\t\t.stacked {\n\t\t\tleft: 0;\n\t\t}\n\t\tion-item {\n\t\t\tpadding-inline: 0;\n\t\t}\n\n\t\t&:first-child {\n\t\t\tpadding-right: 7px;\n\t\t}\n\t\t&:last-child {\n\t\t\tpadding-left: 7px;\n\t\t}\n\t}\n}\n.input-age {\n\tion-input {\n\t\theight: 100%;\n\t\ttext-align: center;\n\t\tcolor: var(--color-black);\n\t}\n\tion-input:first-child {\n\t\tborder-right: 1px solid #cbd5e1;\n\t}\n\tion-input:last-child {\n\t\tborder-left: 1px solid #cbd5e1;\n\t}\n}\nion-footer {\n\t--background: transparent;\n\tbox-shadow: none;\n}\n.loading {\n\theight: 50vh;\n\talign-items: center;\n}\n\n.wrapper {\n\t@include mobile {\n\t\tpadding: 50px 15px 0;\n\t}\n\n\t@include desktop {\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t}\n}\n\n.button-wrapper {\n\tdisplay: flex;\n\tflex-direction: column;\n\tposition: relative;\n\tjustify-content: space-between;\n\twidth: 100%;\n\tmargin-top: auto;\n\tion-button {\n\t\twidth: 100%;\n\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\tjustify-content: flex-start;\n\t\t--background: var(--ion-color-secondary);\n\n\t\t@include desktop {\n\t\t\tmin-height: 64px;\n\t\t\tfont-size: 20px;\n\t\t}\n\t\tp {\n\t\t\tmargin-top: 5px;\n\t\t\tcolor: white;\n\t\t\twidth: 75%;\n\t\t}\n\t}\n}\n.wrapper-modal {\n\t@include mobile {\n\t\tborder-bottom: none;\n\t\t// border: 2px solid var(--color-black);\n\t\tbox-shadow: rgba(0, 0, 0, 0.1) -1px -13px 12px;\n\t\toverflow-y: auto;\n\t\toverflow-x: hidden;\n\t}\n\n\theight: 100%;\n\tposition: relative;\n\tbackground: var(--ion-color-gray-light);\n\tion-item {\n\t\t--background: var(--ion-color-gray-light);\n\t}\n\n\t.close-icon {\n\t\tposition: absolute;\n\t\ttop: 15px;\n\t\tright: 15px;\n\t\tmargin: 0px;\n\t\tbackground: var(--color-white-accent);\n\t\twidth: 18px;\n\t\theight: 18px;\n\t\tpadding: 0px;\n\t\tz-index: 99;\n\t}\n\t.title-text {\n\t\twidth: 100%;\n\t\ttext-align: center;\n\t\tcolor: var(--color-black);\n\t\ttext-transform: uppercase;\n\t\tmargin: 30px 0 5px;\n\t\tfont-size: 24px;\n\t\tfont-weight: bold;\n\t\tletter-spacing: 0.08em;\n\t\t@include desktop {\n\t\t\tpadding-top: 0px;\n\t\t}\n\t}\n\t.subtitle-text {\n\t\tfont-family: AppFontAlt;\n\t\tdisplay: none;\n\t\twidth: 100%;\n\t\ttext-align: center;\n\t\tcolor: var(--color-black);\n\t\tpadding: 10px;\n\t\tletter-spacing: 0.02em;\n\t\t// text-wrap: balance;\n\t\t@include desktop {\n\t\t\tdisplay: block;\n\t\t\tfont-size: 12px;\n\t\t\tpadding: 10px;\n\t\t\tmargin-bottom: 10px;\n\t\t}\n\t}\n\t.header-block {\n\t\tpadding: 20px;\n\t\t@include desktop {\n\t\t\theight: 100%;\n\t\t\tpadding: 20px 40px 5px;\n\t\t}\n\t}\n}\n.underline {\n\t--border-width: 0px;\n\tborder: none !important;\n\tcolor: var(--primary-btn);\n}\n.error_container {\n\tmargin-bottom: 10px;\n}\n\n@include desktop {\n\tion-button {\n\t\tmin-height: 50px !important;\n\t\tfont-size: 18px !important;\n\t\t&:hover {\n\t\t\t--background: var(--primary-btn) !important;\n\t\t}\n\t}\n}\n.terms_error {\n\t.input-error {\n\t\tposition: absolute;\n\t\ttop: -12px;\n\t\tz-index: 9;\n\t}\n}\n.input_info {\n\tposition: absolute;\n\ttop: 0;\n}\n\n.birth {\n\tposition: relative;\n\n\t@include desktop {\n\t\tmargin-bottom: 30px;\n\t}\n\n\t&:after {\n\t\tcontent: '';\n\t\theight: 1px;\n\t\tbottom: 6px;\n\t\tposition: absolute;\n\t\twidth: 100%;\n\t\topacity: 0.5;\n\t\tbackground: #26262680;\n\t}\n}\n.line {\n\tborder-top: 1px solid #262626;\n    position: absolute;\n    left: -40px;\n    right: -40px;\n    top: -20px;\n}\n","@mixin desktop {\n  @media (min-width: 991px) {\n    @content;\n  }\n}\n\n@mixin mobile {\n  @media (max-width: 992px) {\n    @content\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
